//index.tsx
import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import AppShell from "./AppShell";

ReactDOM.render(
  <React.StrictMode>
    <AppShell />
  </React.StrictMode>,
  document.getElementById("root")
);